import Vue from 'vue';
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
	state: {
		name: "生产概况看板"
	},
	getters: {
		getName: state => {
			return state.name;
		}
	},
	mutations: { 
		changeName: (state,data) => {
			state.name = data;
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js